import httpClient from '~utils/httpClient';
import { API_ENDPOINTS } from './constants';

export function fetchPermissions() {
  return httpClient.get(API_ENDPOINTS.fetchPermissions);
}
